'use client';

import { useEffect, useState } from 'react';

/**
 * Hook to get the current header offset for sticky positioning
 *
 * This calculates the height of the header so that sticky elements
 * can be positioned below it correctly.
 *
 * @returns number - The pixel offset from the top of the viewport
 */
export function useHeaderOffset(): number {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const calculateOffset = () => {
      // Try to find the header element
      const header = document.querySelector('header');
      if (header) {
        const headerRect = header.getBoundingClientRect();
        setOffset(headerRect.height);
      } else {
        // Fallback to CSS custom property if available
        const cssOffset = getComputedStyle(document.documentElement).getPropertyValue(
          '--header-height'
        );
        if (cssOffset) {
          setOffset(parseInt(cssOffset, 10) || 0);
        }
      }
    };

    // Calculate on mount
    calculateOffset();

    // Recalculate on resize
    window.addEventListener('resize', calculateOffset);
    return () => window.removeEventListener('resize', calculateOffset);
  }, []);

  return offset;
}
